/* eyecream-problems.js — slow auto-scroll to the end (mobile only), pausable via drag/swipe */
(function () {
  var track = document.getElementById('problemsTrack');
  if (!track) return;

  var mq = window.matchMedia('(max-width:860px)');
  var rafId = null;
  var resumeTimer = null;
  var dragging = false;
  var dragStartX = 0;
  var dragStartScroll = 0;

  /* scrollLeft starts at 0 in both directions, so its sign can't tell us which way
     is "forward" — modern browsers use the negative model for RTL (0 → -max),
     so forward means subtracting in RTL and adding in LTR. This theme sets RTL via
     CSS (direction:rtl on .eyecream-scope), not a dir="rtl" attribute, so check the
     track's own computed direction rather than document.documentElement.dir. */
  var dirMul = (getComputedStyle(track).direction === 'rtl') ? -1 : 1;
  var SPEED = 0.4; // px per frame — slow, continuous

  function maxScroll() {
    return track.scrollWidth - track.clientWidth;
  }

  function step() {
    var max = maxScroll();
    if (max <= 0) { rafId = null; track.classList.remove('is-autoplaying'); return; }
    if (Math.abs(track.scrollLeft) >= max - 1) {
      rafId = null;
      track.classList.remove('is-autoplaying');
      resumeTimer = setTimeout(function () {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        resumeTimer = setTimeout(play, 900);
      }, 1200);
      return;
    }
    track.scrollLeft += SPEED * dirMul;
    rafId = requestAnimationFrame(step);
  }

  function play() {
    if (!mq.matches || dragging || rafId) return;
    /* scroll-snap fights a rAF-driven scrollLeft nudge every frame — turn it off while autoplaying */
    track.classList.add('is-autoplaying');
    rafId = requestAnimationFrame(step);
  }

  function stop() {
    track.classList.remove('is-autoplaying');
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
  }

  function pauseThenResume(delay) {
    stop();
    resumeTimer = setTimeout(play, delay || 1800);
  }

  /* Pointer Events unify touch/mouse and avoid the synthetic-mouse-event-after-touch
     double firing that mobile/in-app browsers are notorious for. */
  if (window.PointerEvent) {
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') {
        dragging = true;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      }
      stop();
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerType !== 'mouse') return;
      track.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
    });
    var endPointer = function () {
      if (dragging) {
        dragging = false;
        track.classList.remove('is-dragging');
      }
      pauseThenResume();
    };
    track.addEventListener('pointerup', endPointer);
    track.addEventListener('pointercancel', endPointer);
  } else {
    track.addEventListener('touchstart', function () { stop(); }, { passive: true });
    track.addEventListener('touchend', function () { pauseThenResume(); }, { passive: true });

    track.addEventListener('mousedown', function (e) {
      dragging = true;
      dragStartX = e.clientX;
      dragStartScroll = track.scrollLeft;
      stop();
      track.classList.add('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      track.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
    });
    window.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      pauseThenResume();
    });
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', function (e) { e.matches ? play() : stop(); });
  }

  play();
})();
